const FAV_CACHE_KEY = "favoritesCache";
const CACHE_TTL_MS = 2 * 60 * 1000;

const inflight = new Map();
const favEpoch = new Map();

const readCache = (key, userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(`${key}:${userId}`);
    if (!raw) return null;
    const { savedAt, data } = JSON.parse(raw);
    if (data == null || !savedAt || Date.now() - savedAt > CACHE_TTL_MS) return null;
    return data;
  } catch {
    return null;
  }
};

const writeCache = (key, userId, data) => {
  if (!userId) return;
  try {
    localStorage.setItem(`${key}:${userId}`, JSON.stringify({ savedAt: Date.now(), data }));
  } catch {
    /* quota or private mode */
  }
};

const dedupe = (key, run) => {
  const existing = inflight.get(key);
  if (existing) return existing;
  const promise = Promise.resolve()
    .then(run)
    .finally(() => {
      if (inflight.get(key) === promise) inflight.delete(key);
    });
  inflight.set(key, promise);
  return promise;
};

export const loadFavoritesCache = (userId) => {
  const data = readCache(FAV_CACHE_KEY, userId);
  return Array.isArray(data) ? data : null;
};

export const saveFavoritesCache = (userId, list) => {
  writeCache(FAV_CACHE_KEY, userId, Array.isArray(list) ? list : []);
};

/** Drop the saved favorites list so the next open loads the cart that was just saved. */
export const invalidateFavoritesCache = (userId) => {
  if (!userId) return;
  favEpoch.set(userId, (favEpoch.get(userId) || 0) + 1);
  try {
    localStorage.removeItem(`${FAV_CACHE_KEY}:${userId}`);
  } catch {
    /* ignore */
  }
  inflight.delete(`fav:${userId}`);
};

export const fetchFavoritesList = (api, userId) => {
  const epoch = favEpoch.get(userId) || 0;
  return dedupe(`fav:${userId}`, async () => {
    const res = await api.get("/api/favorites");
    const list = Array.isArray(res?.data?.favorites) ? res.data.favorites : [];
    if ((favEpoch.get(userId) || 0) === epoch) saveFavoritesCache(userId, list);
    return list;
  });
};

/** Warm the favorites page while the user is still on another screen. */
export const prefetchFavoritesPageData = (api, userId) => {
  if (!userId) return Promise.resolve();
  if (loadFavoritesCache(userId)) return Promise.resolve();
  return fetchFavoritesList(api, userId).catch(() => {});
};
